var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnauthorised401(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 44,
    viewBox: "0 0 46 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M40 41V1c0-.552-.448-1-1-1h-4c-.552 0-1 .448-1 1v40h6zM12 41V1c0-.552-.448-1-1-1H7c-.552 0-1 .448-1 1v40h6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B3B3B3",
    d: "M2 41H16V44H2zM30 41H44V44H30zM6 24H12V26H6zM34 24H40V26H34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M45 4H1c-.552 0-1 .448-1 1v18c0 .552.448 1 1 1h44c.552 0 1-.448 1-1V5c0-.552-.448-1-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M2 6H44V22H2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E24545",
    d: "M44 15.036l-9-9h9v9zm-25-9h8l16 16h-8l-16-16zm8 16h-8l-16-16h8l16 16zm-25-9l9 9H2v-9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F2AA3E",
    d: "M12 4H5.966V1c0-.552.448-1 1-1H11c.552 0 1 .448 1 1v3zM40 4h-6.034V1c0-.552.448-1 1-1H39c.552 0 1 .448 1 1v3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnauthorised401);
export default __webpack_public_path__ + "static/media/Unauthorised401.fc6660a120c7fad54c62327a80e2d169.svg";
export { ForwardRef as ReactComponent };